export const DEFAULT_ROUTE = "/";
export const MAIN = "/service";
export const SUB_SERVICE = "/service/:id/:sname";
export const SUB_SERVICE_DETAIL = "/sub-service/:id/:mid/:sname";
export const CANCELLATION = "/cancellation";
export const BOOKED = "/booked";
export const APPOINTMENT_BOOKING = "/appointment-booking";
export const APPOINTMENT = "/appointment";
export const SERVICE_CHANNEL = "/service-channel";
export const ACTION_CONFIRMATION = "/action-confirmation";
export const OTP_FORM = "/otp-form";
export const APPOINTMENT_CONFIRMATION = "/appt-confirmation";
export const APPOINTMENT_ACKNOWLEDGEMENT = "/appt-acknowledgement";
export const CALL_APPOINTMENT_CONFIRMATION = "/call-appt-confirmation";
export const CALL_APPOINTMENT_ACKNOWLEDGEMENT = "/call-appt-acknowledgement";
export const APPOINTMENT_EXISTENCE = "/appointment-summary";
// Singpass Landing
export const SING_PASS = "/spld";
// Singpass Callback
export const SING_PASS_CALLBACK = "/spcb";
export const NO_APPOINTMENT = "/no-appointment";
export const STORY = "/story";
export const XLANDING = "/close-acct";
export const XCHOOSEIDTYPE = "/xChooseIdType";
export const XVERIFICATION = "/xVerification";
export const XAPPOINTMENT = "/xAppointment";
export const XCONFIRMATION = "/xConfirmation";
export const XAPPOINTMENTDETAIL = "/xAppointmentDetail";
export const XCANCELSUCCESS = "/xCancelSuccess";

// OAS2
// export const O2FORM = "/form/:mid?/:sid?";
// Optional ? is not supported in react-router version 6
// https://github.com/remix-run/react-router/issues/8554
export const O2FORM = "/form";
export const O2FORM_MID = "/form/:mid";
export const O2FORM_MID_SID = "/form/:mid/:sid";
export const O2IDENTITY = "/identity";
export const O2APPOINTMENT_ENTRY = "/appointment-entry";
export const O2CONTACT_DETAIL = "/contact-detail";
export const O2APPOINTMENT_REVIEW = "/appointment-review";
export const O2APPOINTMENT_INFO = "/appointment-info";
export const O2WELCOME_BACK = "/appointment-welcome";
export const O2DELETED = "/appointment-deleted";


